import React, { useEffect, useState } from 'react';
import { Link, Box,} from '@mui/material';

export const footerLinks = [
  
    <Box mt={2} display="flex" justifyContent="center">
    <Link href="https://www.pokitpal.com" variant="body2" sx={{ mr: 3,  cursor: 'pointer', textDecoration: 'underline', color: 'black' }}>
      Help
    </Link>
    <Link href="https://www.pokitpal.com" variant="body2" sx={{ cursor: 'pointer', textDecoration: 'underline', color: 'black' }}>
      Terms
    </Link>
    <Link href="https://www.pokitpal.com" variant="body2" sx={{ ml: 3, cursor: 'pointer', textDecoration: 'underline', color: 'black'}}>
      Privacy
    </Link>
  </Box>
];
